import React from 'react';
import { ClipboardList, Gavel, HandCoins } from 'lucide-react';

export const Process: React.FC = () => {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-semibold text-slate-900">Hoe wij u helpen</h2>
          <p className="text-slate-600 mt-3 md:mt-4 text-sm md:text-base">Een duidelijk proces zonder verrassingen.</p>
        </div>

        <div className="relative">
          {/* Connector Line (Desktop: Horizontal) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-slate-100 -z-10"></div>
          
          {/* Connector Line (Mobile: Vertical) */}
          {/* Aligned to center of 4rem (w-16) icon -> 2rem (left-8) */}
          <div className="md:hidden absolute top-8 bottom-8 left-8 w-0.5 bg-slate-100 -z-10"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            
            {/* Step 1 */}
            <div className="relative flex md:block items-start gap-6 md:gap-0 text-left md:text-center">
              <div className="w-16 h-16 md:w-24 md:h-24 shrink-0 bg-white border-4 border-slate-50 rounded-full flex items-center justify-center text-brand-800 shadow-sm z-10">
                <ClipboardList className="w-8 h-8 md:w-8 md:h-8" strokeWidth={1.5} />
              </div>
              <div className="pt-2 md:pt-6">
                <h3 className="text-lg font-medium text-slate-900 mb-2 md:mb-3">1. Intake & Beoordeling</h3>
                <p className="text-slate-600 text-sm leading-relaxed md:px-4">
                  We bespreken uw situatie in een gratis gesprek. Is er een aansprakelijke partij? Dan nemen wij uw zaak kosteloos aan.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="relative flex md:block items-start gap-6 md:gap-0 text-left md:text-center">
              <div className="w-16 h-16 md:w-24 md:h-24 shrink-0 bg-white border-4 border-slate-50 rounded-full flex items-center justify-center text-brand-800 shadow-sm z-10">
                <Gavel className="w-8 h-8 md:w-8 md:h-8" strokeWidth={1.5} />
              </div>
              <div className="pt-2 md:pt-6">
                <h3 className="text-lg font-medium text-slate-900 mb-2 md:mb-3">2. Juridische afhandeling</h3>
                <p className="text-slate-600 text-sm leading-relaxed md:px-4">
                  Wij stellen de tegenpartij aansprakelijk, regelen voorschotten en berekenen uw exacte schadevergoeding.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative flex md:block items-start gap-6 md:gap-0 text-left md:text-center">
              <div className="w-16 h-16 md:w-24 md:h-24 shrink-0 bg-white border-4 border-slate-50 rounded-full flex items-center justify-center text-brand-800 shadow-sm z-10">
                <HandCoins className="w-8 h-8 md:w-8 md:h-8" strokeWidth={1.5} />
              </div>
              <div className="pt-2 md:pt-6">
                <h3 className="text-lg font-medium text-slate-900 mb-2 md:mb-3">3. Uitbetaling</h3>
                <p className="text-slate-600 text-sm leading-relaxed md:px-4">
                  U ontvangt de maximale schadevergoeding direct op uw rekening. Wij wikkelen het dossier zorgvuldig af.
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};